import GuestIcon from '@material-ui/icons/ViewList';

import GuestOutList from './GuestOutList';

export default {
  list: GuestOutList,
  icon: GuestIcon,
};
